/** Route the API redirects to at the end of an SSO handshake. */
const SSO_HANDOFF_PATH = '/auth-by-token';

/**
 * Whether the current page load is the SSO landing route completing a handoff.
 *
 * Reads `location` rather than the router service because callers run during app
 * boot, before the router has a current route.
 */
export function isSsoHandoffPath(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.location.pathname.replace(/\/+$/, '') === SSO_HANDOFF_PATH;
}
